import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import styles from './BookingActionSection.module.css'

type Props = {
  isMobile: boolean
  isAuthorized: boolean
  isBookingDisabled: boolean
  onBooking: () => void
  onRedirectLogin: () => void
}

export const BookingActionSection: FC<Props> = ({
  isMobile,
  isAuthorized,
  isBookingDisabled,
  onBooking,
  onRedirectLogin,
}) => {
  const { t } = useTranslation()

  const signInBlock = (
    <>
      <div className={styles.signInButtonContainer}>
        <button onClick={onRedirectLogin}>
          <a className={styles.signInButton}>{t('SPACE_DETAIL.LOGIN_AND_BOOKING_BUTTON')}</a>
        </button>
      </div>

      <p className={styles.attention}>{t('SPACE_DETAIL.ATTENTION_SIGNIN_MESSAGE')}</p>
    </>
  )

  if (!isMobile) {
    return isAuthorized ? (
      <button onClick={onBooking} disabled={isBookingDisabled} className={styles.bookingButton}>
        <label>{t('LOCKER.BUTTON.CREATE_RESERVATION')}</label>
      </button>
    ) : (
      signInBlock
    )
  }

  return isAuthorized ? (
    <button className={styles.mobileBookingButton} disabled={isBookingDisabled} onClick={onBooking}>
      <label>{t('LOCKER.BUTTON.CREATE_RESERVATION')}</label>
      <span className={styles.arrow} />
    </button>
  ) : (
    signInBlock
  )
}
